import { render, staticRenderFns } from "./IconView.vue?vue&type=template&id=61b882da&scoped=true"
import script from "./IconView.vue?vue&type=script&lang=js"
export * from "./IconView.vue?vue&type=script&lang=js"
import style0 from "./IconView.vue?vue&type=style&index=0&id=61b882da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b882da",
  null
  
)

export default component.exports